<template>
  <TheTemplateM class="p-the-page-m09" :step="step" :step-options="stepOptions">
    <template #heading>メールアドレス変更</template>

    <template #body>
      <div class="p-the-page-m09__message c-form-inner--wide">
        <p class="p-the-page-m09__message__text">
          ※この段階ではまだメールアドレスの変更は完了していません。
          <br />ご入力の新しいメールアドレス宛に、【本人認証用URL】を記載したメールを送信しました。
          メールに記載された手順にしたがって、30分以内に本人認証を完了させてください。
          <br />メールが届かない場合は、
          <TextLink
            href="/my-page/email-settings/?back_from=email_confirmation"
            :has-underline="true"
            >こちらより再度入力情報をご確認ください</TextLink
          >。
        </p>

        <div class="p-form-button-group">
          <div class="p-form-button-group__vertical">
            <ButtonMain :tag="'a'" href="/">TOPに戻る</ButtonMain>
          </div>
        </div>
      </div>
    </template>
  </TheTemplateM>
</template>

<script lang="ts">
import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import TextLink from "@/common/components/atoms/TextLink.vue";

import { Options, Vue } from "vue-class-component";

import commons from "@/common/store/modules/commons";
import AuthStorage from "@/general/utils/auth";

@Options({
  components: {
    TheTemplateM,
    ButtonMain,
    TextLink
  }
})
export default class MyPageEmailConfirmation extends Vue {
  step = 2;
  stepOptions: any = [
    { step: 1, label: "入力" },
    { step: 2, label: "メール確認" },
    { step: 3, label: "本人認証" },
    { step: 4, label: "完了" }
  ];

  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page/",
      pageType: "lower"
    },
    {
      text: "メールアドレス変更",
      url: "",
      pageType: "lower"
    }
  ];

  mounted() {
    AuthStorage.checkLogin();
  }

  created() {
    commons.getBreadcrumb(this.breadcrumb);
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-m09 {
  &__message {
    margin-top: rem(48);

    @include sp {
      margin-top: rem(28);
    }

    &__text {
      // TODO: irregular
      color: #4f4f4f;
      font-size: rem(14);
      line-height: (24/14);

      & + & {
        margin-top: em(1.5);
      }
    }
  }
}
</style>
